import React from 'react';
import { routingData } from "./routing";
import { Navigate, Outlet, useLocation } from 'react-router-dom';



const RedirectRouter = () => {
  let role = sessionStorage.getItem("role");
  const location = useLocation();

  if (!role) {
    return <Outlet />;
  }

  const roleObject = routingData.find((e) => e.role === role)


  return <Navigate to={roleObject.defaultRoute} state={{ from: location }} replace />;
}

export default RedirectRouter